import * as Yup from 'yup'

export const PebbleDailyWorkOrderWorkPerformedSchema = Yup.object().shape({
    id: Yup.number().required(),
    job_detail_id: Yup.number().required(),
    detail_wash_acid_wash: Yup.string().nullable(),
    is_work_performed_section_complete: Yup.boolean()
})
